import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as BellIcon } from './bell.svg';

export const Bell = IconHOC(BellIcon);
